import { Link } from 'react-router-dom';
import { SITE_NAME, SITE_DESCRIPTION, CATEGORIES } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold text-background-50 mb-3 font-heading">{SITE_NAME}</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">{SITE_DESCRIPTION}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">全部分类</Link></li>
              <li><Link to="/category/hot" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门推荐</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">漫画分类</h4>
            <ul className="space-y-2">
              {CATEGORIES.filter((c) => c.key !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.key}>
                  <Link to={`/category/${cat.key}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li><i className="ri-mail-line mr-2"></i>contact@hanhancomic.com</li>
              <li><i className="ri-customer-service-2-line mr-2"></i>客服 QQ：123456789</li>
              <li><i className="ri-time-line mr-2"></i>周一至周日 9:00 - 22:00</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {SITE_NAME} 版权所有 | 本站所有漫画均来自网络，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}